import Modal from '@components/modal/Modal';
import { Space, Typography } from 'antd';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MdClose, MdOutlineSupportAgent } from 'react-icons/md';

import ClappingHands from '../../images/icons/ClappingHands.svg';
import { useContactSales } from './useContactSales';

const { Text } = Typography;

interface IContactSalesModal {
  isOpen: boolean;
  onClose: () => void;
  userId?: string;
  // Where the modal was opened from, for analytics
  source: string;
}

const ContactSalesModal: React.FC<IContactSalesModal> = ({
  isOpen,
  onClose,
  userId,
  source,
}) => {
  const { t } = useTranslation('rentNavigator', { keyPrefix: 'trial' });
  const { t: tRentNavigator } = useTranslation('rentNavigator');
  const { isSubmitted, isLoading, submitContactSales } = useContactSales(
    source,
    userId,
  );

  const renderContactSales = () => (
    <Space orientation="vertical" className="tw-max-w-[500px]" size="middle">
      <Trans
        components={{
          text: (
            <Text className="tw-font-medium tw-text-[--color-text-weaker]" />
          ),
        }}
      >
        {t('trialExpiredDescription')}
      </Trans>
    </Space>
  );

  const renderSubmitted = () => (
    <Space orientation="vertical" className="tw-max-w-[500px]" size="middle">
      <img
        alt="request-submitted-logo"
        src={ClappingHands}
        height={80}
        width={80}
        className="tw-flex tw-place-self-center"
      />
      <Text strong className="tw-w-full tw-text-center">
        {t('supportRequestNotificationSuccessTitle')}
      </Text>
      <Trans
        components={{
          text: (
            <Text className="tw-font-medium tw-text-[--color-text-weaker]" />
          ),
        }}
      >
        {t('supportRequestNotificationSuccessDesc')}
      </Trans>
    </Space>
  );

  return (
    <Modal
      isOpen={isOpen}
      title={t('trialExpiredTitle')}
      renderModalContent={() =>
        isSubmitted ? renderSubmitted() : renderContactSales()
      }
      cancelIcon={MdClose}
      cancelLabel={tRentNavigator('goBack')}
      okIcon={MdOutlineSupportAgent}
      okLabel={t('contactSalesButton')}
      okLoading={isLoading}
      onHandleCancel={onClose}
      onHandleOk={submitContactSales}
      renderFooter={!isSubmitted}
    />
  );
};

export default ContactSalesModal;
